<div class="login-body">
    @if (app.mainConfig?.authRules != null) {
    <div class="login-panel">
        <div class="col-12">
            <img src="assets/layout/images/logo-login.png" />
            <h1>Login</h1>
            <h2>{{app.appName}}</h2>
        </div>
        @switch (status) {
            @case ("login") {
                <sm-form class="mt-5" [form]="form"></sm-form>
            }
            @case ("inputInformation") {
                <sm-form class="mt-5" [form]="inputInformationForm"></sm-form>
            }
        }
    </div>
    }
</div>
<p-toast position="top-center"></p-toast>
